import { LOCAL_CONSTANT } from '../../Const'

export const longpage_status_check = (params: any) => {
    let check_message = ""

    if (
        params.objLocationBase.location_excel_flag === "" ||
        params.objLocationBase.location_excel_flag === "0"
    ) {
        // check_message += "・中間生成物が取り込まれていません\n"
        check_message += LOCAL_CONSTANT.ALERT_MESSAGE.ALERT_LOCATION_EXCEL_FLAG
    }
    let over_count_date = false
    params.objTrafficVolume.map((row: any) => {
        var today = new Date();
        var dt = new Date(row.count_date);
        // 60日前
        today.setDate(today.getDate() - 60)
        // 60日前以前の場合メッセージ表示
        if(today > dt){
            over_count_date = true
        }
    })
    if  (over_count_date) {
        check_message += LOCAL_CONSTANT.ALERT_MESSAGE.ALERT_60DAYS_OVER_COUNT_DATE
    }
    if  (params.objN15AddMarket.length === 0) {
        check_message += LOCAL_CONSTANT.ALERT_MESSAGE.ALERT_EMPTY_N15ADDMARKET
    }

    return check_message
}

//確認、完了チェックデータセット
export const researchCheckData = (res:any) => {
    const DataObj = {
            plan_area_id: res[0].plan_area_id,  
            branch: res[0].branch, 
            create_date: res[0].create_date,
            update_date: res[0].update_date,
            delete_flag: res[0].delete_flag,
            sales_forecast_check: res[0].sales_forecast_check,
            sales_forecast_update_user: res[0].sales_forecast_update_user,
            add_survey_check: res[0].add_survey_check,
            add_survey_update_user: res[0].add_survey_update_user,
            other_document_check: res[0].other_document_check,
            other_document_update_user: res[0].other_document_update_user,
            rr_internal_use_check: res[0].rr_internal_use_check,
            rr_internal_use_update_user: res[0].rr_internal_use_update_user,
            cover_check: res[0].cover_check,
            cover_update_user: res[0].cover_update_user,
            storeopeningconditions_check: res[0].storeopeningconditions_check,
            storeopeningconditions_update_user: res[0].storeopeningconditions_update_user,
            trade_area_check: res[0].trade_area_check,
            trade_area_update_user: res[0].trade_area_update_user,
            picture_check: res[0].picture_check,
            picture_update_user: res[0].picture_update_user,
            donation_check: res[0].donation_check,
            donation_update_user: res[0].donation_update_user,
            traffic_check: res[0].traffic_check,
            traffic_update_user: res[0].traffic_update_user,
            conflict_check: res[0].conflict_check,
            conflict_update_user: res[0].conflict_update_user,
            impact_check: res[0].impact_check,
            impact_update_user: res[0].impact_update_user,
            drawing_check: res[0].drawing_check,
            drawing_update_user: res[0].drawing_update_user,
            map_check: res[0].map_check,
            map_update_user: res[0].map_update_user,
    };
    return DataObj;
};

//確認、完了チェックAPI登録
export const upsertResearchCheckParam = (objResearchCheck: any, plan_area_id: any, branch: any) => {
    const params = {
        mode: "regist",
        endPoint: "/location/ResearchCheck/v1/update",
        query: {
            plan_area_id: plan_area_id,
            branch: branch,
            sales_forecast_check: objResearchCheck.sales_forecast_check,
            sales_forecast_update_user: objResearchCheck.sales_forecast_update_user,
            add_survey_check: objResearchCheck.add_survey_check,
            add_survey_update_user: objResearchCheck.add_survey_update_user,
            other_document_check: objResearchCheck.other_document_check,
            other_document_update_user: objResearchCheck.other_document_update_user,
            rr_internal_use_check: objResearchCheck.rr_internal_use_check,
            rr_internal_use_update_user: objResearchCheck.rr_internal_use_update_user,
            cover_check: objResearchCheck.cover_check,
            cover_update_user: objResearchCheck.cover_update_user,
            storeopeningconditions_check: objResearchCheck.storeopeningconditions_check,
            storeopeningconditions_update_user: objResearchCheck.storeopeningconditions_update_user,
            trade_area_check: objResearchCheck.trade_area_check,
            trade_area_update_user: objResearchCheck.trade_area_update_user,
            picture_check: objResearchCheck.picture_check,
            picture_update_user: objResearchCheck.picture_update_user,
            donation_check: objResearchCheck.donation_check,
            donation_update_user: objResearchCheck.donation_update_user,
            traffic_check: objResearchCheck.traffic_check,
            traffic_update_user: objResearchCheck.traffic_update_user,
            conflict_check: objResearchCheck.conflict_check,
            conflict_update_user: objResearchCheck.conflict_update_user,
            impact_check: objResearchCheck.impact_check,
            impact_update_user: objResearchCheck.impact_update_user,
            drawing_check: objResearchCheck.drawing_check,
            drawing_update_user: objResearchCheck.drawing_update_user,
            map_check: objResearchCheck.map_check,
            map_update_user: objResearchCheck.map_update_user,
        },
    };
    return params;
};
